import React, { Fragment, useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import "react-toastify/dist/ReactToastify.css";
import DataTableExtensions from "react-data-table-component-extensions";
import moment from "moment";
import { useSelector, useDispatch } from "react-redux";
import DeleteConfirmForSelected from "../common/deleteConfirmForSelected";
import { deleteSelectedOrders, getOrders } from "../../reducers/adminReducers";
import { Dropdown, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import * as XLSX from "xlsx";
import { currencyFormat } from "../../utils/currencyFormater";

const ListDatatable = ({
  id,
  myData,
  myClass,
  multiSelectOption,
  pagination,
  setActiveId,
  setOpen,
  setPayload,
  selectedlen,
  selected,
}) => {
  const dispatch = useDispatch();
  const [data, setData] = useState();
  const result = useSelector((state) => state.admin);
  const { adminSetting } = result || {};
  const { boxProfit } = adminSetting || {};
  const [selectedBox, setSelectedBox] = useState([]);
  const [openDelPopup, setOpenDelPopup] = useState(false);
  const [selectedRows, setSelectedRows] = useState(true);
  const [dummyData, setdummyData] = useState();

  const handleStatusChange = (statusType, rowId, displayName) => {
    setOpen(true);
    setActiveId(rowId);
    setPayload({
      orderId: rowId,
      status: statusType,
      displayName: displayName,
    });
  };
  useEffect(() => {
    setData(myData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [myData, boxProfit]);

  const createAddress = (data) => {
    let address = "";
    if (data) {
      [
        "firstname",
        "lastname",
        "addressLine1",
        "addressLine2",
        "city",
        "state",
        "country",
        "zipCode",
      ].forEach((el) => {
        if (data[el]) {
          address = `${address ? `${address}` : address} ${data[el]}`;
        }
      });
    }
    return address;
  };

  useEffect(() => {
    let serverUsers = myData?.map((u) => ({
      "Order Number": u?.orderId?.orderid,
      "Customer Name": u?.userId?.username,
      "Customer Address": createAddress(u?.orderId?.shippingAddress),
      "Ordered Item": u?.productId?.name,
      "Order Quantity": u?.quantity,
      "Items Price": `$ ${u?.price}`,
      "Date/Time": moment(u.createdAt).format("DD/MM/YYYY HH:mm"),
    }));
    setdummyData(serverUsers);
  }, [myData]);

  const handleTextColor = (row) => {
    return {
      color:
        row.status === "processing"
          ? "orange"
          : row.status === "shipped"
          ? "blue"
          : row.status === "delivered"
          ? "green"
          : row.status === "cancel"
          ? "red"
          : "#ffc60b",
      fontWeight: "bold",
      textTransform: "capitalize",
    };
  };

  const columnDefs = [
    {
      name: "Order Id",
      selector: (row) => row?.orderId?.orderid,
      sortable: true,
    },

    {
      name: "Order By",
      selector: (row) => row?.userId?.username,
      sortable: true,
    },
    {
      name: "Items Price",
      selector: (row) => currencyFormat(row?.price),
      sortable: true,
    },

    {
      name: "Order Status",
      cell: (row) => <span style={handleTextColor(row)}>{row?.status}</span>,
      sortable: true,
    },

    {
      name: "Date/Time",
      selector: (row) => moment(row?.createdAt).format("DD/MM/YYYY HH:mm"),
      sortable: true,
    },
    {
      name: "User Type",
      selector: (row) => "User",
      sortable: true,
    },
    {
      name: "Action",
      cell: (row) => (
        <ShipmentStatus row={row} handleStatusChange={handleStatusChange} />
      ),
    },
  ];

  const handleSelectOrders = (row) => {
    let selectedPro = [];
    if (!row.allSelected) {
      row?.selectedRows.forEach((el) => {
        selectedPro?.push(el?._id);
      });
      setSelectedBox(selectedPro);
      setSelectedRows(true);
    }
    if (row.allSelected) {
      row?.selectedRows.forEach((el) => {
        selectedPro?.push(el?._id);
      });
      setSelectedBox(selectedPro);
      setSelectedRows(true);
    }
  };
  const handleSelectedDelete = async (e, id) => {
    e.preventDefault();
    const res = await dispatch(deleteSelectedOrders(id));
    const { resultData } = res?.payload;
    if (resultData?.code === 200) {
      dispatch(getOrders());
      setOpenDelPopup(false);
      setSelectedRows(false);
    }
  };
  const onCloseModal = () => {
    setOpenDelPopup(false);
  };
  const selectDeleteOpen = (e) => {
    e.preventDefault();
    if (selectedBox.length > 0) {
      setOpenDelPopup(true);
    }
  };

  let downloadFilename =
    "order-" + moment(new Date()).format("DD-MM-YYYY-HH-mm");

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(dummyData || []);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "OrdersList");
    XLSX.writeFile(workbook, `${downloadFilename}.xlsx`);
  };

  return (
    <div>
      <div className="api-doc-content">{/* <h1>ppppppp</h1> */}</div>
      <DeleteConfirmForSelected
        open={openDelPopup}
        handleSelectedDelete={handleSelectedDelete}
        onCloseModal={onCloseModal}
        id={selectedBox}
      />

      <div className="btn-popup pull-right">
        <span className="btn btn-secondary 	mr-2" onClick={selectDeleteOpen}>
          Delete
        </span>
      </div>

      <Button className="btn mt-2 btn-dwnld" onClick={handleDownloadExcel}>
        Download in Excel
      </Button>

      <Fragment>
        <DataTableExtensions
          columns={columnDefs}
          data={data}
          print={false}
          export={false}>
          <DataTable
            data={data}
            columns={columnDefs}
            className={myClass}
            pagination
            striped={true}
            center={true}
            selectableRows
            clearSelectedRows={selectedRows}
            onSelectedRowsChange={(e) => handleSelectOrders(e)}
          />
        </DataTableExtensions>
      </Fragment>
    </div>
  );
};

const ShipmentStatus = ({ row, handleStatusChange }) => {
  return (
    <>
      <div className="action-btn action_btn_dot">
        <Dropdown>
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <i
              className="fa fa-ellipsis-v"
              style={{
                width: 35,
                fontSize: 20,
                padding: 11,
                color: "#e4566e",
              }}></i>
          </Dropdown.Toggle>

          <Dropdown.Menu>
            {/* Processing  */}
            {/* <Dropdown.Item
              className={
                row.status === "cancel" ||
                row.status === "shipped" ||
                row.status === "delivered" ||
                row.status === "processing"
                  ? "disabled"
                  : ""
              }>
              <div
                onClick={() =>
                  handleStatusChange("processing", row._id, "processing")
                }>
                Process
              </div>
            </Dropdown.Item> */}

            {/* Shipped  */}

            <Dropdown.Item
              className={
                row.status === "cancel" ||
                row.status === "shipped" ||
                row.status === "delivered"
                  ? "disabled"
                  : ""
              }>
              <div
                onClick={() =>
                  handleStatusChange("shipped", row._id, "shipped")
                }>
                Shipped
              </div>
            </Dropdown.Item>

            {/* Delivered */}
            <Dropdown.Item
              className={
                row.status === "cancel" || row.status === "delivered"
                  ? "disabled"
                  : ""
              }>
              <div
                onClick={() =>
                  handleStatusChange("delivered", row._id, "delivered")
                }>
                Delivered
              </div>
            </Dropdown.Item>

            {/* Cancel   */}

            <Dropdown.Item
              className={
                row.status === "cancel" ||
                row.status === "shipped" ||
                row.status === "delivered"
                  ? "disabled"
                  : ""
              }>
              <div
                onClick={() => handleStatusChange("cancel", row._id, "cancel")}>
                Cancel
              </div>
            </Dropdown.Item>
            <Dropdown.Item
              className={row?.status === "cancel" ? "disabled" : ""}>
              <Link to={`/order-details?id=${row?._id}`}>Order Details</Link>
            </Dropdown.Item>
            <Dropdown.Item
              className={row?.status === "cancel" ? "disabled" : ""}>
              <Link to={`/invoice-details?id=${row?._id}`}>Get bill</Link>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
};
export default ListDatatable;
